<template>
  <div>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('patrol_logs.unit_log.unit') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          :placeholder="$t('patrol_logs.unit_log.select_unit')"
          @input="(val) => $emit('update:unitFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('patrol_logs.unit_log.active') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="activeFilter"
          :options="activeOptions"
          class="w-100"
          :reduce="(val) => val.value"
          :placeholder="$t('patrol_logs.unit_log.select_status')"
          @input="(val) => $emit('update:activeFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    vSelect,
  },
  props: {
    unitOptions: {
      type: Array,
      default: () => [],
    },
    unitFilter: {
      type: Array,
      default: null,
    },
    activeOptions: {
      type: Array,
      default: () => [],
    },
    activeFilter: {
      type: [Boolean, null],
      default: null,
    },
  },
}
</script>
